import React from "react";
import CookieConsent from "react-cookie-consent";
import { StaticQuery, graphql } from "gatsby";
import Header from "./layout/header/header";
import Footer from "./layout/footer/footer";
import "./layout.css";
import "./layout/custom-css/app.css";

function Layout(props) {
  const { children } = props;

  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={(data) => (
        <div className="site">
          <Header siteTitle={data.site.siteMetadata.title} />
          <main className="site-content">{children}</main>
          <Footer />
          <CookieConsent
            buttonText="Megértettem"
            style={{ background: "white", color: "black" }}
          >
            Kedves Látogató! Tájékoztatjuk, hogy honlapunkon a felhasználói
            élmény fokázása érdekében sütiket alkalmazunk. A honlapunk
            használatával ön a tájékoztatásunkat tudomásul veszi.{" "}
            <a className="link" href="https://szelencecafe.hu/cookie">
              További információ
            </a>
          </CookieConsent>
        </div>
      )}
    />
  );
}

export default Layout;
